<template>
  <div class="input-container">
    <input
      ref="checkItem"
      type="checkbox"
      :id="'option-' + _uid"
      @change="$emit('input', $event.target.checked)"
      :value="checkData"
      :checked="value"
    />
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
    >
      <polygon
        style="fill: #004481"
        points="202.624,478.016 0,291.36 70.512,214.8 191.968,326.656 431.44,33.984 512,99.904 "
      />
    </svg>
    <label :for="'option-' + _uid">{{ label }}</label>
    <div>
      <span class="error" v-if="error">
        <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
        <p>{{ error }}</p>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
    value: Boolean,
    label: String,
    analyticsName: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      checkData: null
    };
  },
  computed: {
    error() {
      if (!this.value && this.checked) {
        return "Tenés que aceptar el contrato";
      }
      return null;
    }
  },
  methods: {
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isValid() {
      if (this.required) {
        return this.value;
      }
      return true;
    }
  }
};
</script>

<style scoped>
div.input-container {
  position: relative;
  width: 100%;
}

/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="checkbox"] {
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 28px;
  height: 28px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  margin-top: 0px;
  margin-right: 8px;
  cursor: pointer;
  border-radius: 2px;
  background-color: #ffffff;
  border: solid 2px #c1c1c1;
}

label {
  cursor: pointer;
  position: absolute;
  top: 5px;
}

/* Estilos para errores */

label.error {
  color: #b92a45;
}

input.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

svg {
  display: block;
  position: absolute;
  left: 8px;
  top: 5px;
  width: 20px;
  height: 20px;
  pointer-events: none;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease-out;
}

/* appearance for checked radiobutton */
input[type="checkbox"]:focus {
  outline: none;
}

input[type="checkbox"]:checked + label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

input[type="checkbox"]:checked + svg {
  opacity: 1;
  transform: scale(1);
}
</style>
